import React from 'react';
import { CheckCircleFillIcon } from '@chegg-ui/horizon-icons';
import { colors } from '@chegg-ui/theme';
import { spacing } from '@chegg-ui/theme';
import { FlexWrapperSC, LogoSC, MarginBottomSC, TypographySC } from "../../common/styles/common.styles";
import { getTexts } from "../../utils/texts";
import { ShimmerTitleTextSC } from "./SignInLoader.styles";
export var SignInLoader = function SignInLoader() {
  var _getTexts = getTexts(),
    signIn = _getTexts.informationMessages.signIn;
  return /*#__PURE__*/React.createElement(FlexWrapperSC, {
    "data-test": "signin_loader_modal"
  }, /*#__PURE__*/React.createElement(LogoSC, null, /*#__PURE__*/React.createElement(CheckCircleFillIcon, {
    size: "large",
    color: colors.orange700
  })), /*#__PURE__*/React.createElement(MarginBottomSC, {
    marginBottom: spacing.px16
  }), /*#__PURE__*/React.createElement(TypographySC, {
    variant: "h2",
    variantType: "bold"
  }, signIn.title), /*#__PURE__*/React.createElement(MarginBottomSC, {
    marginBottom: spacing.px16
  }), /*#__PURE__*/React.createElement(ShimmerTitleTextSC, {
    "data-test": "signin_loader_shimmer",
    width: 90,
    size: "lg"
  }), /*#__PURE__*/React.createElement(MarginBottomSC, {
    marginBottom: spacing.px12
  }), /*#__PURE__*/React.createElement(ShimmerTitleTextSC, {
    width: 30,
    size: "lg"
  }), /*#__PURE__*/React.createElement(MarginBottomSC, {
    marginBottom: spacing.px24
  }), /*#__PURE__*/React.createElement(ShimmerTitleTextSC, {
    width: 50,
    size: "sm"
  }), /*#__PURE__*/React.createElement(MarginBottomSC, {
    marginBottom: spacing.px8
  }), /*#__PURE__*/React.createElement(ShimmerTitleTextSC, {
    width: 20,
    size: "sm"
  }), /*#__PURE__*/React.createElement(MarginBottomSC, null));
};